// Institute of Design and Innovation (email idi@unm.edu). //

export default class AuthService {
  /**
   * Determines if the user has a given permissions
   * @param userValue The user's permission value
   * @param requiredValue The id of the required permissionos
   */
  static authorize (userValue: number, permissionId: number): boolean {
    const requiredValue = Math.pow(2, permissionId)
    return userValue >= requiredValue
  }
}
